export function showElement(el: Element | null) {
  return el?.classList.remove('hidden')
}
export function hideElement(el: Element | null) {
  return el?.classList.add('hidden')
}
